module.exports = __webpack_public_path__ + "img/中山大学.cbf80043.png";